import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Enterprise } from 'app/models/enterprise.model';
import { User } from 'app/models/user.model';
import { EnterpriseService } from 'app/services/enterprise/enterprise.service';
declare const swal: any;
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  firstName: string;
  lastName: string;

  enterprise: Enterprise = {
    enterpriseName: 'Juanito Alachofas News',
    name: 'Juan',
    lastName: 'Perez',
    phone: '809-299-2525',
    mobile: '829-999-2323',
    address: 'Calle Alli No. 2 Ensanche Naco de los Villa Mella'
  }
  constructor(
    private formBuilder: FormBuilder,
    private enterpriseService: EnterpriseService
  ) { }

  ngOnInit() {
    let loggedUser: User = JSON.parse(sessionStorage.getItem('loggedUser'));
    this.enterpriseService.getEnterprise(loggedUser.databaseId).subscribe(enterprise => {
      this.enterprise = enterprise;
      this.formSetValue(this.enterprise);
      console.log('enterprise loaded!');
      console.log('empresa:', this.enterprise);
    })
  }

  userForm = this.formBuilder.group({
    enterpriseName: new FormControl(this.enterprise.enterpriseName, Validators.required),
    name: new FormControl(this.enterprise.name, Validators.required),
    lastName: new FormControl(this.enterprise.lastName, Validators.required),
    address: new FormControl(this.enterprise.address, Validators.required),
    phone: new FormControl(this.enterprise.phone, Validators.required),
    mobile: new FormControl(this.enterprise.mobile)
  });

  submitForm(){
    this.enterprise.enterpriseName = this.userForm.value.enterpriseName;
    this.enterprise.name = this.userForm.value.name;
    this.enterprise.lastName = this.userForm.value.lastName;
    this.enterprise.address = this.userForm.value.address;
    this.enterprise.phone = this.userForm.value.phone;
    this.enterprise.mobile = this.userForm.value.mobile;
    if(this.userForm.valid){
      this.enterpriseService.saveEnterprise(this.enterprise).subscribe(result => {
        console.log('enterprise data updated!');
    });
    this.openAlert(1);
    }else{
      this.openAlert(0);
    }
  }

  private formSetValue(enterprise: Enterprise){
    this.userForm.setValue({
      enterpriseName:enterprise.enterpriseName,
      name: enterprise.name,
      lastName: enterprise.lastName,
      address: enterprise.address,
      phone: enterprise.phone,
      mobile: enterprise.mobile
    })
  }

  openAlert(type){
    switch (type) {
      case 1:
        swal({
          title: 'Guardado correctamente',
          text: 'Presiona OK para continuar',
          type: 'success',
          timer: 3000,
          showConfirmButton: false
        })
        break;
      case 0:
        swal({
          title: 'Atención',
          text: 'Debes llenar todos los campos requeridos',
          type: 'warning',
          confirmButtonClass: 'btn btn-danger'
        })
    }
  }
}
